<template>
  <div class="proHl2 reveal px-10vw">
    <!-- {{dataItems}} -->
    <ul>
        <li v-for="item in dataItems" :key="item.title">
            <div class="img scroll-clip">
              <!-- __style="clip-path:inset(4% round 25px); -->
              <img :src="getItemImg(item)" :title="item.title" />
            </div>            
            <div class="con">
              <div class="el-size--medium">
                <!-- <div class="fnH1" v-html="item.title"></div> -->
                <h3 class="fnH1" v-html="item.title"></h3>
                <p v-html="item.summary"></p>

                <!-- <div style="border:solid 2px #202020;font-size:10px;">{{item}}</div> -->
                <!-- external_link -->
                <!-- {{getExternalLink(item)}} -->

                <a v-if="getExternalLink(item)!=''" class="xBtn" :href="getExternalLink(item)">Read more</a>
                <a v-else @click="showInfoPopup(item)" class="xCirBtn"><i class="fal fa-plus"></i></a>
              </div>
            </div>
        </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  components: {  },
  data() {
    return {
        popupContent:'',
        testItems:[
            {
              url:"",
              img:"img/_temp/lynx_nextgen.png",
              title:"XD Single-Use Drills",
              summary:"<b>Revolution in a Box!</b><br/>Unique in the market, MIS includes sharp and sterile drills in every MIS LYNX package, providing a simplified drilling procedure while maintaining strict hygiene protocols.",
              content:""
            },
            {
              url:"#",
              img:"https://mis-implants.com/upload/Products/Implant-Systems/Clear-Surface/clear-image.png",
              title:"MIS CLEAR™ Surface",
              summary:"<b>The Future is CLEAR</b><br/>Each MIS LYNX implant is stored in an isotonic saline solution, ensuring the implant’s super-hydrophilicity and quality are maintained from production to placement. 1",
              content:"This is the long content text ... "
            }
        ]
    };
  },
  props: {
    sectionData:{}
  },
  computed: {
    ...mapGetters(["localeString"]),
    dataItems()
    {
      if(this.sectionData && this.sectionData.children.length>0){
          return this.sectionData.children;
      }else{
          return this.testItems;
      }        
    },  
    getMainPageLink()
    {
      return this.parsedLocaleString+"/science/research-library?categories=Clinical%20Cases";
      //return this.parsedLocaleString+"/research-and-development/research-library?categories=Clinical%20Cases";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },
    pageData()
    {
        //alert(this.sectionData.items[0].title);
      return this.sectionData.items;
    }
  },
  methods: 
  {
    getExternalLink(item)
    {
        //<!-- external_link -->
        if(item.external_link && item.external_link.length>0){
          return item.external_link;//test element
        }else{        
            if(item.files[0].external_link && item.files[0].external_link.length>1)
            {
              var exLink = item.files[0].external_link;
              if(exLink.indexOf("https://")>-1){
                return exLink;
              }else{
                return "https://mis-implants.com/"+exLink;          
              }
            }
        }
        return '';
    },
                
    getItemImg(item)
    {
        if(item.img && item.img.length>0){
          return item.img;//test element
        }else{
            //real data item
            //look for the file item
            var fileName = item.files[0].file_url;
            if(fileName.indexOf("https://")>-1){
              return fileName;
            }else{
              return "https://mis-implants.com/upload"+fileName;          
            }
        }
    },
    showInfoPopup(item)
    {
        this.$emit('onShowPopupRequest',item);
        //this.popupContent = item.content;
    }
    //...mapActions(["setGalleryIndex", "setGalleryChildren"]),
  }
};
</script>

<style scoped>

    .xBtn
    {
        font-size: 16px;
        font-weight: 200 !important;
        border-radius: 30px;
        padding: 14px 30px;
        border: solid 1px #ddd;  
        color: #2d2d2d;
        position: relative;
        top: 30px;
        cursor: pointer;
        transition: all ease 0.22s;
        display: inline-block;
    }
    .xBtn:hover{
        border: solid 1px #30a9f6;  
        color: #fff;
        background: #30a9f6;
    }
    .xCirBtn
    {
        margin-top: 25px;
        border: solid 1px #ddd;
        border-radius: 100px;
        width: 40px;
        height: 40px;
        display: flex;
        align-content: center;
        align-items: center;
        text-align: center;
        cursor: pointer;
        transition: all ease 0.22s;
    }
    .xCirBtn i
    {
      margin: auto;font-weight: 100 !important;color: #2d2d2d;
      transition: all ease 0.22s;
    }

    .xCirBtn:hover{
        border: solid 1px #30a9f6;  
        color: #fff;
        background: #30a9f6;
    }    
    .xCirBtn:hover i
    {
      color: #fff;
    }

    .proHl2
    {
        width: 100%;
        min-height: 100px;
        color: #202020;
        padding: 2vw 5vw 0vw 5vw;        
    }
    .proHl2 .psTitle
    {
        color: #202020;
        width: 100%;
    }
    .proHl2 ul
    {
        padding-top: 40px;
        list-style: none;
    }
    .proHl2 ul li
    {
        text-align:left;
        background:transparent; /* keep minimalist; add border or bg if desired */
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 60px;
        padding-bottom: 50px;
    }
    .proHl2 ul li:nth-child(odd) .img
    {
        order: 2;
    }


    .proHl2 ul li .img
    {
        background: transparent;
        height: 26vw;
        width: 100%;
        position: relative;        
    }

    .proHl2 ul li img
    {
      border-radius: 20px;
        height: 100%;
        width: 100%;
        object-fit: fill;
    }


    .proHl2 ul li .con
    {
        display: flex;
        align-items: center;
    }
    .proHl2 ul li .fnH1
    {
        color: #202020;
        width: 70% !important;
    }
    .proHl2 ul li p
    {
        width: 70%;
        padding-top: 20px;
        color: #202020;
    }

    @media (hover: hover) {
    }

    @media screen and (max-width: 815px)
    {
        .proHl2
        {
            padding: 5vw 5vw;
        }
        .proHl2 ul
        {
            grid-template-columns: 1fr;
        }
        .proHl2 ul li
        {
            grid-template-columns: repeat(1, 1fr);
            gap: 30px;
            padding-bottom: 100px;
        }
        .proHl2 ul li img
        {
          order: 1;
        }
        .proHl2 ul li .con
        {
          order: 2;
        }

        .proHl2 ul li .fnH1,
        .proHl2 ul li p
        {
          width: 100%;
        }
        .proHl2 ul li .img
        {
            height: 55vw;
            width: 100%;
            position: relative;
        }        
    }


    @media only screen and (min-width:2000px)
    {
    }
</style>
